import { useContext } from "react";
import { RequestContext } from "../request-context";
import { criticityPill } from "../utils/criticity";
import { date2HumanString } from "../utils/date";
import { requestGet, requireResult } from "../utils/network";
import { showBoolean } from "../utils/security";
import ActionButton from "../widget/action-button";
import ButtonsGroup from "../widget/buttons-group";
import { Modes } from "../widget/io-abstract";
import IOBoolean from "../widget/io-boolean";
import SearchPanel, { type FormValues } from "../widget/search-panel";
import TablePanel from "../widget/table-panel";
import type { User } from "./_objects-users";

export default function PageUsers(): React.ReactNode {
  //
  // React context
  //
  const requestContext = useContext(RequestContext)!;

  const onSearch = (formData: FormValues): Promise<React.ReactNode> =>
    requestContext
      .fetchJSONAndMessage<User[]>(
        "Getting list",
        requestGet("/api/user", formData)
      )
      .then(requireResult)
      .then((users) => (
        <TablePanel
          rows={users}
          headers={
            <thead>
              <tr>
                <th></th>
                <th>Username</th>
                <th>Name</th>
                <th>Email</th>
                <th>Group</th>
                <th>Has password</th>
                <th>In Examiner List</th>
                <th>Last Login</th>
                <th>Password Criticity</th>
                <th>Profile Criticity</th>
              </tr>
            </thead>
          }
          lineLink={(user) => `/user/${user.id}`}
          lineColumns={(user) => {
            return (
              <>
                <td>{user.username}</td>
                <td>{user.name}</td>
                <td>{user.email}</td>
                <td>{user.group}</td>
                <td>{showBoolean(user.has_password)}</td>
                <td>{showBoolean(user.in_examiner_list)}</td>
                <td>
                  {criticityPill(
                    user.last_login
                      ? new Date(user.last_login).getTime() <
                        new Date().getTime() - 365 * 24 * 60 * 60 * 1000
                        ? "WARNING"
                        : undefined
                      : "CRITICAL",
                    user.last_login
                      ? date2HumanString(new Date(user.last_login))
                      : "never"
                  )}
                </td>
                <td>{criticityPill(user.password_criticity)}</td>
                <td>{criticityPill(user.profile_criticity)}</td>
              </>
            );
          }}
        />
      ));

  return (
    <div>
      <h1>
        <img src="/static/img/users.png" />
        Users
      </h1>
      <ButtonsGroup>
        <ActionButton linkTo="/user/add" action="Add User" />
      </ButtonsGroup>
      <SearchPanel
        form={
          <>
            <IOBoolean name="with_password" mode={Modes.input} />
          </>
        }
        onSearch={onSearch}
      />
    </div>
  );
}
